import React from 'react';
import pulsaIcon from '../../assets/category-icons/pulsa-icon.svg';
import kuotaIcon from '../../assets/category-icons/kuota-icon.svg';
import listrikIcon from '../../assets/category-icons/listrik-icon.svg';
import pesawatIcon from '../../assets/category-icons/pesawat-icon.svg';
import keretaIcon from '../../assets/category-icons/kereta-icon.svg';
import busIcon from '../../assets/category-icons/bus-icon.svg';
import creditCardIcon from '../../assets/category-icons/credit-card-icon.svg';

const Categories = () => {
  return (
    <div className="container">
      <div className='categories'>
        <ul className="categories-wrapper">
          <li className="category"><img src={pulsaIcon} alt="pulsa icon" /><span>Produk 1</span></li>
          <li className="category"><img src={kuotaIcon} alt="kuota icon" /><span>Produk 2</span></li>
          <li className="category"><img src={listrikIcon} alt="listrik icon" /><span>Produk 3</span></li>
          <li className="category"><img src={pesawatIcon} alt="pesawat icon" /><span>Produk 4</span></li>
          <li className="category"><img src={keretaIcon} alt="kereta icon" /><span>Produk 5</span></li>
          <li className="category"><img src={busIcon} alt="bus icon" /><span>Produk 6</span></li>
          <li className="category"><img src={creditCardIcon} alt="credit card icon" /><span>Produk 7</span></li>
        </ul>
        <p className="categories-see-all">Lihat Semua</p>
      </div>
    </div>
  )
}

export default Categories
